import AtcRoutes from './atc-routes';
import FiltersModule from './atc-flights-view/filters/flight-filters-module';
import AtcCheckController from './controllers/atcCheckController';
import AtcCheckResultController from './controllers/atcCheckResultController';
import AtcCalendarController from './controllers/atcCalendarController';
import AtcFlightsFactory from './services/atcFlightsFactory';
import AtcFlightsService from './services/atcFlightsService';
import AtcCalendarService from './services/atcCalendarService';
import AtcFlightsSearchParamsFactory from './services/atcFlightSearchParams';
import AtcTimeService from './services/atcTimeService';
import AtcSearchCriteriaGroupItem from './atc-check-result/search-criteria-group-item/search-criteria-group-item-module';
import AtcFlightsUtilsFactory from './services/atcFlightUtils';
import AtcApiFactory from './services/atcApi';
import AtcFlightsHeaderBaseController from './controllers/atcFlightsHeaderBaseController';
import AtcFlightsListBaseController from './controllers/atcFlightsListBaseController';
import AtcFlightsController from './controllers/atcFlightsController';
import AtcFlightsListController from './controllers/atcFlightsListController';
import AtcFlightsHeaderController from './controllers/atcFlightsHeaderController';
import AtcFlightsCarouselController from './controllers/atcFlightsCarouselController';
import AtcFlightsCarouselBaseController from './controllers/atcFlightsCarouselBaseController';
import FlightRecommendationModule from './atc-flights-view/flight-recommendation/flight-recommendation-module';
import AtcCurrencyByCode from './filters/atcCurrencyByCode.filter';
import AtcDirectivesModule from './directives/atc-directives-module';

const MODULE_NAME = 'App.Atc';
const module = angular
    .module(MODULE_NAME, [
       AtcSearchCriteriaGroupItem,
       FlightRecommendationModule,
       FiltersModule,
       AtcDirectivesModule,
    ])
    .controller('atcCheckController', AtcCheckController)
    .controller('atcCheckResultController', AtcCheckResultController)
    .controller('atcCalendarController', AtcCalendarController)
    .controller('atcFlightsHeaderBaseController', AtcFlightsHeaderBaseController)
    .controller('atcFlightsListBaseController', AtcFlightsListBaseController)
    .controller('atcFlightsController', AtcFlightsController)
    .controller('atcFlightsHeaderController', AtcFlightsHeaderController)
    .controller('atcFlightsListController', AtcFlightsListController)
    .controller('atcFlightsCarouselController', AtcFlightsCarouselController)
    .controller('atcFlightsCarouselBaseController', AtcFlightsCarouselBaseController)
    .factory('atcFlightsUtils', AtcFlightsUtilsFactory)
    .factory('atcFlightSearchParams', AtcFlightsSearchParamsFactory)
    .factory('atcFFactory', AtcFlightsFactory)
    .factory('atcApiService', AtcApiFactory)
    .service('atcTimeService', AtcTimeService)
    .service('atcFlightsService', AtcFlightsService)
    .service('atcCalendarService', AtcCalendarService)
    .filter('atcCurrencyByCode', AtcCurrencyByCode)
    .config(AtcRoutes);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-module.js